import axios from "axios";

// Create Axios instance
const api = axios.create({
  baseURL: "https://admin.houseofdhanushdhari.com/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
